import React from 'react';
import { useInView } from 'react-intersection-observer';
import { getLocationAttributesForSegment, getRetailerName } from './utils';
import FFLinkButton from '../../buttons/FFLinkButton';
import FridgeLocationTags from '../../tags/FridgeLocationTags';
import useWindowSize from '../../../utils/useWindowSize';
import useSegment, { EVENTS } from '../../../utils/useSegment';
import styles from './StickyHeader.module.css';

/**
 * @param {object} props
 * @param {FF.Location__LDP} props.locationData
 */
export default function LDPStickyHeader({ locationData }) {
  const isFridge = locationData.type === 'FRIDGE';
  const retailerName = getRetailerName(locationData);
  const { pushTrackEvent } = useSegment();
  const { headerHeight: navHeaderHeight = 86 } = useWindowSize() || {};

  const {
    entry,
    inView,
    ref: inViewRef,
  } = useInView({
    initialInView: true,
    fallbackInView: true,
    rootMargin: `${-1 * navHeaderHeight}px 0px 0px 0px`,
  });

  const showHeader =
    !inView && entry && entry.boundingClientRect.top < navHeaderHeight;

  return (
    <>
      <div className={styles.thresholdIndicator} ref={inViewRef} />
      {showHeader && (
        <div
          className={`${styles.wrapper} ${isFridge ? styles.withButton : ''}`}
        >
          {isFridge && (
            <FridgeLocationTags
              className={styles.tag}
              location={locationData}
            />
          )}
          <div className={styles.leftSide}>
            {retailerName && (
              <div className={styles.retailerName}>{retailerName}</div>
            )}
            <h1 className={styles.locationName}>
              {locationData.locationConfigs.prettyName}
            </h1>
            {isFridge && (
              <div className={styles.rightSide}>
                <FFLinkButton
                  onClick={() => {
                    pushTrackEvent(
                      EVENTS.VIEW_MENU,
                      getLocationAttributesForSegment(locationData),
                    );
                  }}
                  buttonType="primary"
                  href={locationData.fridgeSpecificMenuPagePath}
                >
                  View Menu
                </FFLinkButton>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
